import sendBill from "./es/send_bill"
import vote from "./es/vote"

export default {
  sendBill: sendBill,
  vote: vote
}
